import { z } from 'zod';

//todo : align with latest schema

export const createTicketSchema = z.object({
  title: z
    .string()
    .min(1, 'Title is required')
    .max(200, 'Title must be less than 200 characters')
    .trim(),

  description: z
    .string()
    .min(1, 'Description is required')
    .max(5000, 'Description must be less than 5000 characters')
    .trim(),

  customerName: z
    .string()
    .min(1, 'Customer name is required')
    .max(100, 'Customer name must be less than 100 characters')
    .trim(),

  phoneNumber: z
    .string()
    .regex(/^[+]?[(]?[0-9]{1,4}[)]?[-\s./0-9]*$/, 'Invalid phone number format')
    .optional()
    .or(z.literal('')),

  source: z.string().min(1, 'Source is required'),

  group: z.string().min(1, 'Group is required'),

  type: z.string().min(1, 'Type is required'),

  priority: z.enum(['low', 'medium', 'high', 'urgent'], {
    errorMap: () => ({ message: 'Invalid priority level' })
  }),

  category: z.string().min(1, 'Category is required'),

  assignedTo: z.string().optional(),

  tags: z.array(z.string()).default([]),

  attachments: z
    .array(z.instanceof(File))
    .refine((files) => {
      const totalSize = files.reduce((sum, file) => sum + file.size, 0);
      return totalSize <= 10 * 1024 * 1024; // 10MB total limit
    }, 'Total file size must not exceed 10MB')
    .optional()
    .default([]),

  isPublic: z.boolean().default(true),

  customerId: z
    .number()
    .int('Customer ID must be an integer')
    .positive('Customer ID must be positive')
    .optional(),

  status: z.string().optional().default('open')
});
